import React from "react";
import { LetterOfAuthorization, Image, Header, Subheader, Guildelines, Print, LetterWrapper, FontBoldText } from "./styles";
import logo from '../../../../../../../../assets/icons/vcep-logo.png';
import printIcon from "../../../../../../../../assets/icons/print.svg";
import PrintComponents from "react-print-components";
import { StyleLessButton } from "../../../../../../../../CommonComponents/commonStyles";
import { IconPadding,DataExportPrint } from "../../../../styles";
import { removeHeaderFooter } from "../../../../utils";
import { replaceSelect } from "../../../../../../../../utils/replacer";
let wire = [];

export class ViewContribution extends React.Component {

    componentDidMount = () => {
        removeHeaderFooter(); 
    }

    renderPrintData = () => {
        return (
            <LetterOfAuthorization>
            <Image justifyContent = "flex-start" marginBottom="10px">
                    <img src={logo} alt="vanguard"></img>
            </Image>
            <Header>Instructions</Header>
            <Subheader>Contribution by Wire</Subheader>
            <div className="mt-20">
                <div>Your name: {wire.name}</div>
                {wire.type !== "Individual" ? <div>Donor name: { wire.type !== "Joint" ? wire.donorName : (wire.firstName + ' ' +  wire.lastName)}</div> : "" }
                <div>Vanguard Charitable account number: { wire.logAcNum } </div>
                <div>Vanguard Charitable account name: { wire.logAcName }</div>
                <div>Contribution amount: {wire.amount} </div>
            </div>
            <br />
            <div><FontBoldText>Provide your bank with the following wiring instructions.</FontBoldText></div>
            <br />
            <div>
                {wire.drupalContent ? <div dangerouslySetInnerHTML={{ __html: wire.drupalContent }}></div>:
                <>
                <div>Wire to: FRB ABA 011001234 - The Bank of New York Mellon, 225 Liberty St., New York, NY 10286</div>
                <div>For credit to: Account 0724947 - Vanguard Charitable Endowment Program</div>
                <br />
                </>
                }
                {wire.allocationDetails.map((pool) => (
                <div>In favor of: {replaceSelect(pool.name)} Pool Percentage {pool.futureAllocPercentage}%</div>
                ))}
                <div>Vanguard Charitable account number: { wire.logAcNum } </div>
                <div>Vanguard Charitable account name: { wire.logAcName } </div>
            </div>
            <Guildelines>
                If applicable, Vanguard Charitable will send a tax substantiation letter once the contribution is processed.
                For more information, view our <a href={wire.envURL + "/company-policies/policies-and-guidelines"} target="_blank">
                <span>Policies and guidelines</span></a> booklet.
            </Guildelines>
        </LetterOfAuthorization> 
        )
    }

    render() {
        wire = [];
        wire = JSON.parse(localStorage["wire"]);
        return (
                     <LetterWrapper> 
                     <PrintComponents
                        className="i_print"
                        trigger={
                          <Print>
                          <StyleLessButton>
                            <IconPadding className="ml2">
                              <img src={printIcon} alt="print"/>
                              <DataExportPrint>PRINT</DataExportPrint>
                            </IconPadding>
                          </StyleLessButton>
                          </Print>
                        } >
                            {this.renderPrintData()}
                        </PrintComponents>
                     {this.renderPrintData()}</LetterWrapper>
            );
                
    }
}

export default ViewContribution;


